const AGENDAMENTO_STATUS = {
  AGUARDANDO: 0,
  NEGADO: 1,
  CONFIRMADO: 2,
};

export default AGENDAMENTO_STATUS;
